import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { utils } from '@blend/ui-common';
import { WindowWrapper } from 'login-utils/globalWrappers';
import { loginBackgroundDynamicColor } from 'login-stylesheets/deploymentColors';
import { fonts } from '@blend/consumer-components';
import ArrowBackButton from '../ArrowBackButton/ArrowBackButton';

const styles = StyleSheet.create({
  backButton: {
    ...fonts.Roboto,
    color: loginBackgroundDynamicColor,
    fontSize: 14,
  },
});

function goBackToPreviousApplication() {
  const previousSelectedProductId = utils.cookieUtils.get('previousSelectedProductId');
  if (!previousSelectedProductId) return;

  utils.cookieUtils.set('selectedProductId', previousSelectedProductId, { path: '/' });
  WindowWrapper.location.reload();
}

export default class BackToPreviousApplicationButton extends React.PureComponent {
  render() {
    return (
      <div className={css(styles.backButton)}>
        <ArrowBackButton onClick={goBackToPreviousApplication} />
      </div>
    );
  }
}
